exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.info-texts p[data-v-06ff2b9e] {\n  margin: 10px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-exclude-certificate-modal/ScExcludeCertificateModal.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"ScExcludeCertificateModal.vue","sourcesContent":["\n.info-texts p[data-v-06ff2b9e] {\n  margin: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06ff2b9e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-exclude-certificate-modal/ScExcludeCertificateModal.vue
// module id = NQ8q
// module chunks = 72